import { DataLayerItem, EventWithAnalytics } from '../types';

export const createGaEvent = (dataGaValues: DataLayerItem) => {
  const event: EventWithAnalytics = new Event('analytics-event');
  event.dataGaValues = dataGaValues;

  return event;
};

export const dispatchGaEvent = (event: EventWithAnalytics) => {
  if (!document) {
    return;
  }
  document.dispatchEvent(event);
};
